

export class MembroDTO {

    id: string;

    nome: string;

    cognome: string;

    email: string[];

    pec: string;

    codiceFiscale: string;

    presidenteCollegio: boolean;

}
